<template>
  <transition name="modalbg">
    <div @click.self="closeModal" class="modal_container">
      <transition name="modal" v-on:before-leave="modalClose">
        <div v-if="showed" class="modal">
          <div class="caption">
            <div class="title-modal">{{textContent.titleAdd}}</div>
            <div @click="closeModal" class="close"></div>
          </div>
          <div class="modal-scroll" :class="{ 'in-last-tab' : isLastTab }">
            <div class="modal-content">
              <form v-on:submit.prevent="addItem">
                <form-input name="title"></form-input>
                <form-input name="url"></form-input>
                <form-text-editor name="text" editor-id="editor"></form-text-editor>
                <form-input name="seo_title"></form-input>
                <form-text-area name="keywords"></form-text-area>
                <form-text-area name="description"></form-text-area>
                <form-file use-case="seo" name="seo_image"></form-file>
                <form-file use-case="banner" name="banner_image"></form-file>
              </form>
            </div>
          </div>
          <div class="buttons">
            <div class="next">
              <button @click="closeModal" class="cancel">{{textContent.cancelButton}}</button>
              <button class="confirm" @click="onAddItem">{{textContent.submitButton}}</button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
  import IconAlignleft from '@/components/icons/IconAlignleft'
  import IconSignalbars from '@/components/icons/IconSignalbars'
  import IconArrowbold from '@/components/icons/IconArrowbold'
  import FormInput from '@/components/create-form/Input'
  import FormTextArea from '@/components/create-form/TextArea'
  import Calendar from '@/components/create-form/Calendar'
  import FormFile from '@/components/create-form/File'
  import FormDropDown from '@/components/create-form/DropDown'
  import FormTextEditor from '@/components/create-form/TextEditor'
  import {createNamespacedHelpers} from 'vuex'
  import Tabs from '@/components/create-form/Tabs'
  import Checkbox from '@/components/create-form/Checkbox'

  const {mapMutations, mapActions, mapState, mapGetters} = createNamespacedHelpers('mainPage')

  export default {
    data () {
      return {
        showed: false,
      }
    },
    computed: {
      ...mapState([
        'textContent',
        'fields'
      ]),
      ...mapGetters([
        'getDataFromEditor',
        'isLastTab'
      ]),
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId () {
        return this.$store.state.parentId
      }
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev',
        'checkTabAwailability',
      ]),
      ...mapMutations([
        'setField',
        'resetTextEditor',
        'setTabs',
        'setCurrentTabId',
        'setFileExtensions'
      ]),
      onAddItem () {
        this.setField({fieldId: 'text', fieldPropertyId: 'value', value: this.fields.text.editor.getData()})
        this.addItem()
      },
      closeModal () {
        this.showed = false
      }
    },
    mounted () {
      this.showed = true
    },
    created () {
      this.setCurrentTabId(0)
      this.setFileExtensions({seo_image: ['jpg', 'jpeg', 'png', 'gif'], banner_image: ['jpg', 'jpeg', 'png', 'gif']})
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Заголовок страницы (h1)',
          errorId: null,
          errors: {empty: 'Введите название страницы'},
          tabId: 0
        },
        url: {
          value: '',
          parameterName: 'url',
          name: 'Ссылка',
          errorId: null,
          errors: {empty: 'Введите ссылку страницы'},
          tabId: 0
        },
        seo_image: {
          value: '',
          parameterName: 'seo_image',
          name: 'Изображение',
          errorId: null,
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 1
        },
        banner_image: {
          value: '',
          parameterName: 'banner_image',
          name: 'Баннер',
          errorId: null,
          errors: {empty: 'Выберите баннер', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 1
        },
        text: {
          value: '',
          parameterName: 'text',
          name: 'Текст',
          isNullable: true,
          errorId: null,
          errors: {empty: 'Введите текст'},
          tabId: 0,
        },
        seo_title: {
          value: '',
          parameterName: 'seo_title',
          name: 'Название страницы (title)',
          errorId: null,
          errors: {empty: 'Напишите название страницы'},
          tabId: 0
        },
        keywords: {
          value: '',
          parameterName: 'keywords',
          name: 'Ключевые слова',
          errorId: null,
          errors: {empty: 'Напишите ключевые слова'},
          tabId: 0
        },
        description: {
          value: '',
          parameterName: 'description',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Напишите краткое описание'},
          tabId: 0
        },
      })
    },
    components: {
      Checkbox,
      IconAlignleft,
      IconSignalbars,
      IconArrowbold,
      FormInput,
      FormTextArea,
      FormFile,
      FormDropDown,
      FormTextEditor,
      Tabs,
      Calendar
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/pages/CreateModal.vue